import script from "./OrderConfirmedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderConfirmedPage.vue?vue&type=script&setup=true&lang=js"

import "./OrderConfirmedPage.vue?vue&type=style&index=0&id=7ad442f2&lang=scss"

const __exports__ = script;

export default __exports__